
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","fill-rule":"evenodd","d":"M20.308 9.184l-1.434.51a1.994 1.994 0 00-.997.78l-2.121 3.2a3.001 3.001 0 00-.518 1.69v1.49c.001.266-.103.521-.289.71l-.418.41a.993.993 0 01-1.405 0l-7.032-7.07a1.003 1.003 0 010-1.41l.408-.45a.994.994 0 01.708-.29h1.484c.6 0 1.187-.18 1.683-.52l3.187-2.13c.36-.24.633-.59.777-1l.508-1.44a.994.994 0 011.644-.37l4.183 4.2a1 1 0 01.3.952.994.994 0 01-.668.738zm-15.848 8.3a3.014 3.014 0 00-.667 1l-.757 1.83a.502.502 0 00.11.54c.14.141.352.185.537.11l1.803-.72a2.98 2.98 0 00.996-.67l2.899-2.91-2.012-2.1-2.909 2.92z"}})])
          )
        }
      }
    